import {
  ButtonGroup as ChakraButtonGroup,
  ButtonGroupProps,
} from '@chakra-ui/react';

export const ButtonGroup = ({ children, ...props }: ButtonGroupProps) => (
  <ChakraButtonGroup {...props}>{children}</ChakraButtonGroup>
);
